import { __decorate, __metadata } from "tslib";
import { provide } from '@/inversify.config';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { getReportTemplates } from 'library-@/apis/matrix_api/matrix_api.js';
/**
 * 模板来源
 */
export var ReportSource;
(function (ReportSource) {
    /**
     * 用户创建
     */
    ReportSource[ReportSource["USER"] = 1] = "USER";
    /**
     * 系统推荐
     */
    ReportSource[ReportSource["SYSTEM"] = 2] = "SYSTEM";
    /**
     * 英策报告
     */
    ReportSource[ReportSource["INSIGHTS"] = 3] = "INSIGHTS";
})(ReportSource || (ReportSource = {}));
/**
 * 报告来源：1-模版，2-报告
 */
export var ReportType;
(function (ReportType) {
    /**
     * 模板
     */
    ReportType[ReportType["TEMPLATE"] = 1] = "TEMPLATE";
    /**
     * 报告
     */
    ReportType[ReportType["REPORT"] = 2] = "REPORT";
})(ReportType || (ReportType = {}));
export const ReportTemplateService = Symbol('ReportTemplateService');
const defaultViewModel = {
    showNoTemplate: false,
    showNoSearchResult: false,
    reportSource: 1,
    catalog: undefined,
    filterKeyword: '',
    filterResult: [],
    filterResultLoading: false,
    filterResultError: false,
};
let ReportTemplateServiceImpl = class ReportTemplateServiceImpl {
    constructor() {
        this._onModelChangeEmitter = new Emitter();
        this.onModelChange = this._onModelChangeEmitter.event;
        this._onFilterResultChangeEmitter = new Emitter();
        this.onFilterResultChange = this._onFilterResultChangeEmitter.event;
        this._viewModel = { ...defaultViewModel };
        this._fireModelChange();
    }
    _fireModelChange() {
        this._onModelChangeEmitter.fire({ ...this._viewModel });
    }
    getViewModel() {
        return { ...this._viewModel };
    }
    setReportSource(reportSource) {
        this._viewModel.reportSource = reportSource;
        this._viewModel.catalog = undefined;
        this._viewModel.filterKeyword = '';
        this._fireModelChange();
    }
    setFilterKeyword(keyword) {
        this._viewModel.filterKeyword = keyword;
        this._viewModel.reportSource = undefined;
        this._viewModel.catalog = undefined;
        this._fireModelChange();
    }
    setCatalog(catalog) {
        this._viewModel.catalog = catalog;
        this._viewModel.reportSource = 2;
        this._viewModel.filterKeyword = '';
        this._fireModelChange();
    }
    async fetchReportTemplates() {
        this._viewModel.filterResultLoading = true;
        this._fireModelChange();
        let data;
        let result;
        if (this._viewModel.reportSource === ReportSource.INSIGHTS) {
            data = {
                data: [],
                total: 1,
                totalWithoutFilter: 1,
                page: 1,
                pageSize: 20,
                totalPage: 1,
            };
            result = data;
        }
        else {
            const reportSource = this._viewModel.reportSource;
            data = await this.query({
                keyword: this._viewModel.filterKeyword,
                catalog: this._viewModel.catalog,
                reportSource,
            });
            result = data;
            if (reportSource) {
                const t = data.data.filter((item) => item.reportSource === reportSource);
                result = {
                    ...data,
                    total: t.length,
                    data: t,
                };
            }
        }
        this._viewModel.filterResultLoading = false;
        this._viewModel.filterResult = result.data;
        this._viewModel.showNoTemplate = result.totalWithoutFilter === 0;
        this._viewModel.showNoSearchResult = (result.total === 0) && (result.totalWithoutFilter !== 0);
        this._fireModelChange();
        this._onFilterResultChangeEmitter.fire(result.data);
        return data;
    }
    async query(query) {
        const req = {
            report_source: query.reportSource,
        };
        const resp = await getReportTemplates(req);
        let data = resp.map((item) => ({
            id: item.id,
            name: item.title,
            catalog: item.tag || '',
            updatedAt: item.updated_at,
            cover: item.icon,
            reportType: ReportType.TEMPLATE,
            reportSource: item.report_source,
        }));
        const totalWithoutFilter = data.length;
        if (query.keyword) {
            data = data.filter((item) => item.name.toLowerCase().includes((query.keyword || '').toLowerCase()));
        }
        if (query.catalog) {
            data = data.filter((item) => item.catalog === query.catalog);
        }
        const total = data.length;
        const result = {
            total,
            totalWithoutFilter,
            data,
            page: 1,
            pageSize: total,
            totalPage: 1,
        };
        return result;
    }
};
ReportTemplateServiceImpl = __decorate([
    provide(ReportTemplateService),
    __metadata("design:paramtypes", [])
], ReportTemplateServiceImpl);
export { ReportTemplateServiceImpl };
